import Image from "next/image";

import AppDownloadBtn from "@domains/landing/components/AppDownloadBtn/AppDownloadBtn";

import * as S from "./Meta.style";

const Meta = () => {
  return (
    <S.Container>
      <S.Section1>
        <S.TitleH5>
          {"Still wondering what to do\nthis weekend in seoul?"}
        </S.TitleH5>

        <S.TitleH5>Now</S.TitleH5>

        <S.TitleH2>
          It`s time to <strong>Enkoplay</strong>
        </S.TitleH2>
      </S.Section1>

      <S.Section2>
        <S.Content>
          {"Surpassed 4K users in 3months,\n60% re-engagement."}
        </S.Content>

        <S.TitleH6>
          Different <strong>Languages,</strong>
        </S.TitleH6>
        <S.TitleH6>
          But Same <strong> Tastes!</strong>
        </S.TitleH6>

        <S.Logo>
          <Image fill src="/logo/enkoplay-logo.svg" alt="main-logo" />
        </S.Logo>

        <AppDownloadBtn
          text={"Download the app now\n& check out this week's events."}
        />
      </S.Section2>
    </S.Container>
  );
};

export default Meta;
